const API_BASE_URL = process.env.REACT_APP_API_ADDRESS;

export const get2FASetup = async () => {
    const response = await fetch(`${API_BASE_URL}/accounts/2fa/`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
            'Content-Type': 'application/json',
        },
    });
    const data = await response.json();
    return data;
};

export const verify2FACode = async (code) => {
    const response = await fetch(`${API_BASE_URL}/accounts/2fa/`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ code }),
    });
    return await response.json();
};

export const disable2FA = async () => {
    const res = await fetch(`${API_BASE_URL}/accounts/2fa/`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
            'Content-Type': 'application/json',
        },
    });

    return {
        success: res.ok,
        statusCode: res.status,
    };
};
